
import React, {createContext, useContext, ReactNode, useState} from 'react';

interface AppDataContextProps {
  widget_type: string | null;
  prompt_type: string | null;
  userId: string;
  userClass: string;
  logourl: string;
  badgeurl: string;
  error_message: string;
  should_present_legal_banner: boolean;
  client_id: string;
  client_token: string;
  article_index: string | undefined
  follow_up_question: string | undefined
  proxy: string | undefined;
  welcome_message: string;
  language_for_widget: string | null | undefined;
  floatingState: any;
  setLanguage?: (language: string | null | undefined) => void;
  setFollowUpQuestion?: (follow_up_question: string | undefined) => void;
  asset_type: string | undefined;
  asset_symbol: string | undefined;
  follow_up_questions: string[] | undefined;
  language_for_chat: string | null | undefined;
  root: any | undefined;
  ActionList?: { className: string | null; srcUrl: string | null }[];
  actionDataContextProps?: (ActionDataContextProps | { [key: string]: any })[] | null;
}

interface ActionDataContextProps {
  action?: string;
  actionKey?: string;
  actionTag?: string;
  className?: string;
  inputs?: any;
}

export let AppDataContext = createContext<AppDataContextProps | undefined>(undefined);

export const useAppContext = () => {
  const context = useContext(AppDataContext);
  if (!context) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
};

interface AppProviderProps {
  children: ReactNode;
  value: AppDataContextProps;
}

export const AppProvider: React.FC<AppProviderProps> = ({ children, value }) => {
 // const [language_for_widget, setLanguage] = useState<string | null | undefined>(value.language_for_widget);
 // const [follow_up_question, setFollowUpQuestion] = useState<string | undefined>(value.follow_up_question);

  return (
    <AppDataContext.Provider value={{ ...value,
      //language_for_widget,
      //follow_up_question,
     // setLanguage,
      //setFollowUpQuestion
    }}>
      {children}
    </AppDataContext.Provider>
  );
};
